import { Highlight } from 'components/Images/Highlights/HighlightTypes'
import { useState } from 'react'
import {
  PdfFeature,
  PdfPage,
} from 'services/APIs/InternalAPI/internal-api.contracts'
import { Vect2D } from '../ZoomAndPanImg'

export const useZoomAndPanStates = () => {
  const [highlights, setHighlights] =
    useState<
      Record<
        string,
        { highlight: Highlight; pdfPage: PdfPage; pdfFeature: PdfFeature }
      >
    >(undefined)
  const [isLoading, setIsLoading] = useState<-1 | 0 | 1>(-1)
  const [scale, setScale] = useState(1)
  const [position, setPosition] = useState<Vect2D>({ x: 0, y: 0 })
  const [rotation, setRotation] = useState('0deg')

  return {
    highlights,
    setHighlights,
    isLoading,
    setIsLoading,
    scale,
    setScale,
    position,
    setPosition,
    rotation,
    setRotation,
  }
}
